import { useEffect, useState } from "react";
import { hvoAuth } from "configs/FirebaseConfig";
import { hasHvoSession } from "data/hooks";

/**
 * Whether this session may write to Halalvlees Online, as a value React re-renders on.
 *
 * `hasHvoSession()` is a point-in-time read of `hvoAuth.currentUser`, and Firebase restores a
 * session asynchronously after the page loads - so a screen that only asks once can paint its
 * HVO rows as locked and never unlock them. Subscribing means the row state follows the real
 * session instead of whatever was true during the first render.
 *
 * `loginToBothFirebase` swallows a failed HVO login and continues with VCE only, so "signed in"
 * genuinely does not imply "may write to HVO"; this is the value the screen disables on.
 */
export const useHvoSession = () => {
  const [available, setAvailable] = useState(hasHvoSession);

  useEffect(() => {
    const unsubscribe = hvoAuth.onAuthStateChanged(() => setAvailable(hasHvoSession()));
    return () => unsubscribe();
  }, []);

  return available;
};
